import { render } from "./ActivitiesScreen.vue?vue&type=template&id=e988288c"
import script from "./ActivitiesScreen.vue?vue&type=script&lang=js"
export * from "./ActivitiesScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__